import React, { Component} from 'react'
import { connect } from 'react-redux'
import { Row, Col, Card, Button, Breadcrumb } from 'react-bootstrap'
import Header from '../Header'
import Spinner from 'react-bootstrap/Spinner'
import { toast } from 'react-toastify';
import 'moment/locale/es';
import data, { key_local_storage_user } from '../../lib/backend/data'
import { Link } from 'react-router-dom'
import 'moment/locale/es';
import Switch from "react-switch";
import { validateEmail } from '../../lib/helpers/helpers'
import { cerrarSesion } from '../../redux/actions/session'
class UsuariosCrear extends Component {
    constructor(props){
        super(props)
        this.state = {
            user: JSON.parse(localStorage.getItem(key_local_storage_user)),
            usuario: {
                activo: true
            },
            loadingUsuarios: false,
            creandoUsuario: false,
            comunas_descartar_creacion: [],
            show_password: false
        }
        this.handleChangeUsuario = this.handleChangeUsuario.bind(this)
        this.handleChangeChecked = this.handleChangeChecked.bind(this)
    }

    handleChangeUsuario(e){
        const { usuario } = this.state
        const { name, value } = e.target
        usuario[name] = value
        return this.setState({ usuario })
    }

    handleChangeChecked(checked){
        return this.setState({ show_password: checked })
    }

    crearUsuario(){
        const { usuario, user } = this.state
        const requeridos = [
            { value:'nombres', label: 'Nombres' },
            { value:'apellidos', label: 'Apellidos' },
            { value:'email', label: 'Email' },
            { value:'password', label: 'Contraseña' },
            { value:'role', label: 'Rol de usuario' },
        ]
        let faltantes = []
        requeridos.map(campo => {
            if(!usuario[campo.value]) faltantes.push(campo.label)
            return true
        })
        if(faltantes.length > 0) return toast.error(`Faltan campos: ${faltantes.join(', ')}`)
        if(validateEmail(usuario.email) !== true) return toast.error('Email inválido')
        if(usuario.password.length < 5) return toast.error('La contraseña debe tener al menos 5 carácteres')
        if(usuario.password !== usuario.password_confirm) return toast.error('Las contraseñas no coinciden')
        const loading = 'creandoUsuario'
        this.setState({ [loading]: true })
        return fetch(`${data.urlapi}/usuarios`,{
            method:'POST',
            body: JSON.stringify( usuario ),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer: ${user.tokenSession}`
            }
        })
        .then(res => {
            if(res.status === 401) return this.props.cerrarSesion()
            return res.json()
        })
        .then(res => {
            console.log(res)
            if(!res){
                toast.error('Sin datos')
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(res._id){ 
                toast.success('Guardado exitosamente')
                setTimeout(() => {
                    return window.location = '/usuarios'
                }, 500);
            }
            this.setState({ [loading]: false })
        })
        .catch(error => {
            this.setState({ [loading]: false })
            toast.error("Error al realizar esta operación, intente nuevamente", this.state.toaststyle)
        })
    }

    formularioUsuario(){
        const { loadingUsuarios, creandoUsuario, show_password } = this.state
        if(loadingUsuarios) return <Spinner animation='border' />

        return <div>
            <Row>
                <Col md={2} className="mb-3">
                    <label className='form-control-label'>Nombres</label>
                    <input name="nombres" className='form-control' onChange={this.handleChangeUsuario} />
                </Col>
                <Col md={2} className="mb-3">
                    <label className='form-control-label'>Apellidos</label>
                    <input name="apellidos" className='form-control' onChange={this.handleChangeUsuario} />
                </Col>
                <Col md={2} className="mb-3">
                    <label className='form-control-label'>Email</label>
                    <input name="email" className='form-control' onChange={this.handleChangeUsuario} />
                </Col>
                <Col md={2} className="mb-3">
                    <label className='form-control-label'>Rol de usuario</label>
                    <select name="role" className='form-control' onChange={this.handleChangeUsuario}>
                        <option value="">Selecciona</option>
                        <option value="user">Usuario</option>
                        <option value="admin">Administrador</option>
                    </select>
                </Col>
                <Col md={12} className="">
                    <h4>Seguridad</h4>
                </Col>
                <Col md={2} className="mb-3">
                    <label className='form-control-label'>Contraseña</label>
                    <input name="password" type={show_password === true ? 'text' : 'password'} className='form-control' onChange={this.handleChangeUsuario} />
                </Col>
                <Col md={2} className="mb-3">
                    <label className='form-control-label'>Repetir contraseña</label>
                    <input name="password_confirm" type={show_password === true ? 'text' : 'password'} className='form-control' onChange={this.handleChangeUsuario} />
                </Col>
                <Col md={2} className="mb-3">
                    <label className='form-control-label d-block'>Mostrar contraseña</label>
                    <Switch onChange={this.handleChangeChecked} checked={show_password} />
                </Col>
                <Col md={12}>
                    {
                        creandoUsuario === true ? <Spinner animation='border' /> : <Button size="sm" variant='success' onClick={()=>this.crearUsuario()}>CREAR </Button>
                    }
                    
                </Col>
            </Row>
            
        </div>
    }

    botonSeleccionar(id){
        const { planes_activos } = this.state
        const i = planes_activos.findIndex(plan => plan._id === id)
        if(i > -1) return <Button size="sm" variant="outline-secondary" >PLAN ACTIVO</Button>

        return <Button size="sm" variant="outline-primary" ><Link to={`pay-plan-${id}`} >SELECCIONAR</Link></Button>
    }
    
    render(){
        return(
            <div className="fluid">
                <Breadcrumb>
        <Breadcrumb.Item href="#"><Link to="/usuarios">Usuarios</Link> </Breadcrumb.Item>
        <Breadcrumb.Item active>Crear</Breadcrumb.Item>
    </Breadcrumb>
    <h4>Crear nuevo usuario </h4>
      <Card >
          <Card.Body>
          {this.formularioUsuario()}
          </Card.Body>
      </Card>
            
    </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        miusuario: state.miusuario
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        cerrarSesion: () => dispatch(cerrarSesion())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(UsuariosCrear);